<template>
    <div>
        <div v-if="type==1" class="slide ad1">

            <div class="bd">
                <ul>
                    <li v-for="(item,index) in list" :style="{display: show == index? 'block':'none',opacity:show == index?swiperOpacity:0}">
                        <a :href="item.url" target="_blank">
                            <img :src="item.images[0].url">
                        </a>
                    </li>
                </ul>
            </div>
            <div class="hd">
                <ul>
                    <li class="elip" v-for="(item,index) in list" :class="{ on:  show == index }">{{item.title}}</li>
                </ul>
            </div>
            <a class="prev" @click="prev()" href="javascript:void(0)"></a>
            <a class="next" @click="next()" href="javascript:void(0)"></a>
        </div>
        <div v-if="type==2" class="slide ad1">

            <div class="bd">
                <ul>
                    <li v-for="(item,index) in list" :style="{display: show == index? 'block':'none',opacity:show == index?swiperOpacity:0}">
                        <img :src="item.path">
                    </li>
                </ul>
            </div>
            <div class="hd">
                <ul>
                    <li class="" v-for="(item,index) in list" :class="{ on:  show == index }">{{item.miaoshu}}</li>
                </ul>
            </div>
            <a class="prev" @click="prev()" href="javascript:void(0)"></a>
            <a class="next" @click="next()" href="javascript:void(0)"></a>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                show: 0,
                swiperOpacity:0
            }
        },
        watch: {
            swiperOpacity(val) {
                if (val >= 5) {
                        this.show = this.show + 1; 
                }
            },
            show(val) {
                if(this.list.length>1)
                {
                this.swiperOpacity = 0;
                }
                else
                {
                this.swiperOpacity = 1;
                }
                if (val > this.list.length - 1) {
                    this.show = 0;
                }
                if (val < 0) {
                    this.show = this.list.length-1;
                }
            }
        },
        mounted() {
            const self = this;
            function changeSwiperOpacity() {
                if (self.list.length > 1) {
                    self.swiperOpacity = ((self.swiperOpacity * 10000 + 50) / 10000).toFixed(
                        6);
                } else {
                    self.swiperOpacity = 1;
                }
            }
            setInterval(changeSwiperOpacity);
        },
        props: ['list', 'type'],
        methods: {
            prev() {
                this.show -= 1;

            },
            next() {
                this.show += 1;
            },
        }
    };
</script>


// WEBPACK FOOTER //
// app/web/component/web/swiper/swiper.vue